import styles from './StakingPill.module.scss'
import IconInfo from '../../IconInfo/IconInfo'

import { Tooltip } from '@/common/components/Tooltip'

interface StakingPillProps {
  bordered?: boolean
  fullWidth?: boolean
  label: string
  smallValue?: string
  tooltip?: string
  value: string | JSX.Element
}

export default function StakingPill({
  bordered = false,
  fullWidth = false,
  label,
  smallValue,
  tooltip,
  value,
}: StakingPillProps) {
  return (
    <div
      className={`${styles.pill} ${bordered ? styles['pill--bordered'] : ''} ${fullWidth ? styles['pill--full'] : ''}`}
    >
      <div className={styles.pill__label}>
        {label}{' '}
        {tooltip && (
          <Tooltip content={tooltip} placement="right">
            <IconInfo />
          </Tooltip>
        )}
      </div>
      <div className={styles.pill__value}>
        {value} {smallValue && <small>{smallValue}</small>}
      </div>
    </div>
  )
}
